
export enum DocumentNameKinds {
  Format = 1,
  Paper = 2,
}
